var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5c0 .75-.597 1.357-1.333 1.357H4.552l5.723 5.827c.52.529.52 1.39 0 1.919s-1.366.53-1.886 0l-8-8.145A1.36 1.36 0 0 1 0 16.505V16.5c0-.176.035-.353.104-.519.066-.164.164-.314.288-.44l8-8.144a1.32 1.32 0 0 1 1.885 0c.52.53.52 1.39 0 1.92l-5.725 5.826h26.115c.736 0 1.333.607 1.333 1.357"
  })));
};
export default SvgArrowLeft;